<template>
    <div class="flex items-center justify-between gap-4">
        <div class="grow">
            <span :id="nameId" class="text-base font-extrabold text-slate-700 text-md">{{ feature.name }}</span>
            <div :id="descriptionId" class="text-sm text-slate-700">{{ feature.description }}</div>
        </div>
        <div class="flex-shrink-0 flex items-center gap-2">
            <vx-toggle
                v-model="feature.enabled"
                @update:modelValue="toggleFeature"
                :disabled="team.status === 'closed' || locked"
                :aria-labelledby="nameId"
                :aria-describedby="descriptionId"
                size="lg"
            ></vx-toggle>
        </div>
    </div>
</template>

<script setup>
import { VxToggle } from '@voxie/frontend-components';
import { computed, ref, useId } from 'vue';
import { adminFeaturesClient } from '~/services';
import { useToasted } from '~/composables/useToasted';
import { useTeamDetails } from '../composables/useTeamDetails';
import { catchRequestError } from '~/utils/request';
import { isProduction } from '~/utils/environment';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const { team, refreshTeam } = useTeamDetails();

const feature = defineModel(Object);
const toasted = useToasted();
const toggling = ref(false);
const nameId = useId();
const descriptionId = useId();

const locked = computed(() => {
    return isProduction() && feature.value.type === 'internal';
});

const toggleFeature = async () => {
    if (toggling.value) {
        return;
    }

    toggling.value = true;

    try {
        if (feature.value.enabled) {
            await adminFeaturesClient.enableFeature(props.teamId, feature.value.id);
            toasted.success(`${feature.value.name} has been enabled.`);
        } else {
            await adminFeaturesClient.disableFeature(props.teamId, feature.value.id);
            toasted.success(`${feature.value.name} has been disabled.`);
        }

        await refreshTeam(props.teamId);
    } catch (e) {
        feature.value.enabled = !feature.value.enabled;
        toasted.error(catchRequestError(e));
    } finally {
        toggling.value = false;
    }
};
</script>
